import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import SingleRankingDisplay from '@/components/streaming-charts/SingleRankingDisplay.vue';
import {
	GetTitleRankingDocument,
	GetTitleRankingQuery,
	GetTitleRankingQueryVariables,
} from '@/components/graphql/queries/GetTitleRanking.query';
import { PopularityRankTypes, StreamingChartInfo, StreamingChartObjectType } from '@/@types/graphql-types';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useQuery } from '@/helpers/composables/useApollo';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleRankingList',
  props: {
    titleId: null,
    objectType: null,
    country: null
  },
  setup(__props: any) {

const props = __props as {
	titleId: string;
	objectType: StreamingChartObjectType;
	country: string;
};



const queryVariables = computed<GetTitleRankingQueryVariables>(() => {
	return {
		country: props.country,
		filter: {
			jwEntityID: props.titleId,
			category: PopularityRankTypes.DailyPopularitySameContentType,
			previousTitles: 0,
			nextTitles: 0,
			objectType: props.objectType,
		},
	};
});
const { result } = useQuery<GetTitleRankingQuery, GetTitleRankingQueryVariables>(
	GetTitleRankingDocument,
	queryVariables
);
const titleRankingData = computed(() => result.value?.streamingCharts?.edges?.[0]?.streamingChartInfo);

return { __sfc: true,props, queryVariables, result, titleRankingData, SingleRankingDisplay, faInfoCircle }
}

})